import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings, iceColumnDefinition } from '../../components/models/icesettings';
import { IcepanelComponent } from '../icepanel/icepanel.component';
import { IcematgridComponent } from '../icepanel/icematgrid.component';

@Component({
  selector: 'icecheckbox',
  templateUrl: './icecheckbox.component.html',
  styleUrls: ['./icecheckbox.component.scss'],
  providers: [IcematgridComponent]
})
export class IcecheckboxComponent implements OnInit {
  // Input Members
  @Input() placeholder: string = "";
  @Input() id: string = "";
  @Input() properties: any = {};
  @Input() ctrl: IcecontrolSettings = null;
  @Input() tableColumn: iceColumnDefinition = null;
  @Input() tableRowData: any = null;

  // Output Members
  @Output() buttonChange: EventEmitter<any> = new EventEmitter<any>();

  // Data Members
  iceFormControl: FormControl = null;

  constructor(
    @Inject(IcepanelComponent) private parent: IcepanelComponent,
    @Inject(IcematgridComponent) private parentTable: IcematgridComponent) {
  }

  ngOnInit() {
    try {
      // To do fix with validation
      if (this.parentTable && this.tableRowData != null && this.tableColumn != null) {
        // tables should not use the standard formcontrol
        let formRowGroup: FormGroup = this.parentTable.getFormGroup(this.tableRowData);
        this.iceFormControl = new FormControl(this.tableRowData[this.tableColumn.columnName]); 
        formRowGroup.addControl(this.tableColumn.columnName, this.iceFormControl);
      }
      else {
        // stardard formcontrol processing
        this.iceFormControl = this.ctrl.getFormControl();
        if (this.iceFormControl == null)
          this.iceFormControl = new FormControl(false); // No control so we create a placeholder control to prevent an errors
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  onChange(event) {
    event.buttonSettings = this.ctrl;
    if (this.parentTable && this.tableRowData != null && this.tableColumn != null && this.parentTable.controlChange) {
      this.tableRowData[this.tableColumn.columnName] = event.checked;
      event.tableColumn = this.tableColumn;
      event.tableRowData = this.tableRowData;

      this.parentTable.onControlChange(event);
    }
    else if (this.parent && this.parent.controlChange)
      this.parent.onControlChange(event);

    this.buttonChange.emit(event);
  }

  getDisabled(): boolean {
    if (this.ctrl == null) return false;

    return this.ctrl.getDisabled() || (this.ctrl.properties != null && this.ctrl.properties.disabled == true);
  }
}
